import { z } from "zod";
/**
 * «Тревоги» (Паша 04.10.2026: «чтобы нерешённые тревоги складывались в какое-то место — я мог прийти и сказать:
 * посмотри нерешённые алерты, нужно с ними разобраться постепенно»): one list of every problem the server's watches
 * see — the server watch itself and the problem files of the others (analytics, promises, the practicum's watch) —
 * with since when, how many times, what to do and who fixes it. The server watch (`host-watch`, every 5 minutes) is
 * the only one that writes to Паша; `hypno-alerts export` writes this list for Vekha, Vekha only reads and shows it.
 */
export const ALERT_STATUSES = ["open", "waiting", "under", "info", "people", "excepted", "closed"];
export const AlertStatusSchema = z.enum(ALERT_STATUSES);
const Text = z.string();
const Moment = z.string().nullable();
export const AlertExceptionSchema = z.object({
    match: Text,
    prefix: z.boolean(),
    reason: Text,
    by: Text.nullable(),
    at: Text.nullable(),
    until: Text.nullable(),
}).strict();
export const AlertItemSchema = z.object({
    /** The watch's key: what an agent passes to `hypno-alerts show|except`. */
    key: Text.min(1),
    /** Which watch saw it: Сервер, Аналитика, Обещания, Веха… */
    source: Text,
    /** Who fixes it. */
    owner: Text.nullable(),
    /** What is broken, in words. */
    text: Text,
    action: Text.nullable(),
    link: Text.nullable(),
    status: AlertStatusSchema,
    /** Why a not-yet-told problem waits: a robot fixes it itself until …, it came back and waits an hour. */
    waiting: Text.nullable(),
    since: Moment,
    announcedAt: Moment,
    clearedAt: Moment,
    lastedSeconds: z.number().int().nonnegative().nullable(),
    /** How many times it opened within the watch's memory (a week). */
    episodes: z.number().int().positive(),
    blinks24h: z.number().int().nonnegative(),
    auto: z.boolean(),
    /** Seen before the watch kept its list: «с … или раньше». */
    adopted: z.boolean(),
    /** The key of the open cause it comes with. */
    under: Text.nullable(),
    exception: AlertExceptionSchema.nullable(),
    zone: Text.nullable(),
}).strict();
export const ALERTS_FILE_STATES = ["ok", "stale", "missing", "unreadable", "invalid"];
export const AlertsCountsSchema = z.object(Object.fromEntries(ALERT_STATUSES.map((status) => [status, z.number().int().nonnegative()]))).strict();
export const AlertsOverviewSchema = z.object({
    /** ok — fresh list; stale — the watch has not written it for 20 minutes; missing / unreadable / invalid. */
    file: z.enum(ALERTS_FILE_STATES),
    generatedAt: Moment,
    /** When the server watch last looked. */
    watchCheckedAt: Moment,
    checkedAt: Text,
    counts: AlertsCountsSchema,
    items: z.array(AlertItemSchema),
    exceptions: z.array(AlertExceptionSchema),
    rejected: z.number().int().nonnegative(),
    fileIssues: z.array(Text),
}).strict();
//# sourceMappingURL=alerts.js.map